"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __importDefault(require("../../config"));
var Timer = /** @class */ (function () {
    function Timer(_a) {
        var _b = _a === void 0 ? {} : _a, callback = _b.callback, delay = _b.delay, _c = _b.autoStart, autoStart = _c === void 0 ? true : _c;
        this.delay = 0;
        this.remaining = 0;
        this.startDate = new Date();
        this.running = false;
        this.ticker = null;
        this.callback = callback;
        // make it milliseconds
        this.delay = (delay ? delay : 0) * 1000;
        this.remaining = this.delay;
        if (config_1.default.instant) {
            this.delay = 5;
            this.start();
        }
        if (autoStart) {
            this.start();
        }
    }
    Timer.hydrate = function (obj) {
        var timer = Object.assign(new Timer(), obj);
        if (timer.remaining > 0) {
            timer.delay = timer.remaining;
            timer.start();
        }
        return timer;
    };
    Timer.prototype.tick = function () {
        this.remaining = this.delay - (+new Date() - +this.startDate);
        if (this.remaining <= 0 || this.remaining === 0) {
            this.triggerCallback();
        }
    };
    Timer.prototype.triggerCallback = function () {
        if (this.running && this.callback) {
            this.callback();
        }
        this.pause();
    };
    Timer.prototype.start = function () {
        var _this = this;
        this.running = true;
        this.startDate = new Date();
        this.ticker = window.setInterval(function () { return _this.tick(); }, config_1.default.tickerTick * 1000);
        this.tick();
    };
    Timer.prototype.pause = function () {
        this.running = false;
        if (this.ticker) {
            window.clearInterval(this.ticker);
            this.ticker = null;
        }
    };
    Timer.prototype.getTimeLeft = function () {
        return this.remaining;
    };
    Timer.prototype.getTimeLeftInSeconds = function () {
        return Math.round(this.getTimeLeft() / 1000);
    };
    Timer.prototype.getTimeoutString = function () {
        var timeoutInSeconds = this.getTimeLeftInSeconds();
        var mins = Math.floor(timeoutInSeconds / 60);
        if (mins > 60) {
            var hours = Math.floor(mins / 60);
            if (hours > 24) {
                var days = Math.floor(hours / 24);
                return "~" + days + " Day";
            }
            return "~" + hours + " Hrs";
        }
        if (mins > 0) {
            return "~" + mins + " Min";
        }
        return timeoutInSeconds + " Sec";
    };
    return Timer;
}());
exports.default = Timer;
